import type { FareEstimate } from '../fares/FareCalculator'
import type { RouteInfo } from '../types'
import type { Language } from '../types'
import type { Translator } from '../i18n/i18n'

interface RouteSummaryProps {
  route: RouteInfo | null
  fare: FareEstimate | null
  loading: boolean
  message: string | null
  language: Language
  t: Translator
}

function formatDistance(meters: number, language: Language): string {
  const formatter = new Intl.NumberFormat(language, { maximumFractionDigits: 1 })
  return meters < 1000 ? `${formatter.format(Math.round(meters))} m` : `${formatter.format(meters / 1000)} km`
}

export function RouteSummary({ route, fare, loading, message, language, t }: RouteSummaryProps) {
  const minutes = Math.max(1, Math.round((route?.durationSeconds ?? 0) / 60))
  return (
    <section className="route-summary" aria-live="polite">
      <h3>{t('routeTitle')}</h3>
      {loading && <p>{t('routeLoading')}</p>}
      {!loading && message && <p className="notice">{message}</p>}
      {!loading && route && (
        <div className="metrics">
          <div><small>{t('estimatedDistance')}</small><strong><bdi>{formatDistance(route.distanceMeters, language)}</bdi></strong></div>
          <div><small>{t('estimatedDuration')}</small><strong><bdi>{t('minutes', { count: minutes })}</bdi></strong></div>
          <div><small>{t('referenceFare')}</small><strong><bdi>{fare ? `${fare.minWon.toLocaleString(language)}~${fare.maxWon.toLocaleString(language)} KRW` : t('tariffNeedsVerification')}</bdi></strong></div>
        </div>
      )}
      <p className="disclaimer">{t('fareDisclaimer')}</p>
    </section>
  )
}
